(function ($) {
  DJ.addBehavior('jcfFormInit', '.js-form-wrapper', {
    attach: function () {
      const formWrapper = this;
      const checkboxes = formWrapper.querySelectorAll('input[type="checkbox"]');
      const select = formWrapper.querySelectorAll('select');
      let file = formWrapper.querySelectorAll('input[type="file"]');
      const svgPath = DJ.getDrupalSettings().isSlicingEnvironment ? '../../assets/sprites/symbol/svg/sprite.symbol.svg' : '/themes/custom/cems_front/public/assets/sprites/symbol/svg/sprite.symbol.svg';
      const passwordField = $('[type="password"]');
      const subjectField = $('.field--name-field-select-your-subject');
      const searchParams = new URLSearchParams(window.location.search);
      const subjectVal = searchParams.get('subject');

      jcf.replace(checkboxes, 'Checkbox');
      if (file.length > 0) {
        jcf.replace(file, 'File', {
          buttonText: Drupal.t('Attach file'),
          placeholderText: file[0].closest('div').dataset.shortDescription
        });
      }
      jcf.replace(select, 'Select', {
        wrapNative: false
      });

      $('.jcf-select-opener', $(this)).append(`<span class="svg-icon"><svg><use xlink:href="${svgPath}#arrow_selector"></use></svg></span>`);

      if (!$(formWrapper).closest('.user-change-password-form').length) {
        $(`<button class="toggle-password"><span class="svg-icon"><svg><use xlink:href="${svgPath}#detail"></use></svg></span></button>`).insertAfter(passwordField);

        $(document).on('click', '.toggle-password', (e) => {
          e.preventDefault();
          $(e.target).toggleClass('active');
          const input = $(e.target).prev();
          if (input.attr('type') === 'password') {
            input.attr('type', 'text');
          } else {
            input.attr('type', 'password');
          }
        });
      }

      if (subjectVal !== null) {
        subjectField.find('select').val(subjectVal);
      }

      subjectField.find('select').on('change', (e) => {
        if ($(e.target).val() !== '_none') {
          searchParams.set('subject', $(e.target).val());
        } else {
          searchParams.delete('subject');
        }

        const urlWithParams = `${window.location.protocol}//${window.location.host}${window.location.pathname}?${searchParams.toString()}`;
        window.history.pushState({ path: urlWithParams }, '', urlWithParams);
      });

      $(document).ajaxComplete(function () {
        file = document.querySelectorAll('input[type="file"]');
        if (file.length > 0) {
          jcf.replace(file, 'File', {
            buttonText: Drupal.t('Attach file'),
            placeholderText: file[0].closest('div').dataset.shortDescription
          });
        }
      });
    }
  });
})(jQuery);
